import { LogComponentCreator } from '@/ui/components/activityLogs/factory/LogComponentCreator';
import { LogEntityComponent } from '@/ui/components/activityLogs/factory/LogEntityComponent';
import { LogComponent } from '@/ui/components/activityLogs/factory/LogComponent';

export class LogCreator extends LogComponentCreator {
  // eslint-disable-next-line class-methods-use-this
  public componentFactory(): LogEntityComponent {
    return new LogComponent();
  }
}
